import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import InfoIcon from "@mui/icons-material/Info";
import { Avatar } from "@mui/material";
import React from "react";
import WidgetsButton from "./WidgetsButton";

import { useNavigate } from "react-router-dom";
import { FaTicketAlt } from "react-icons/fa";

function Widget({ applicationassigneddata, isLoading }) {
  const navigate = useNavigate();


  const screening = applicationassigneddata?.filter((obj: any) => {
    return obj?.applicationStatus === "APPLIED"
  });

  


  const singleWidgets = (title: any, details: any, id: any) => (
    <div className="single_widgets">
      <Avatar
        sx={{
          width: 50,
          height: 50,
          backgroundColor: "white",
          color: "#0a66c2",
          border: "1px solid #0a66c2",
        }}
        src={""}>
        {title[0].toUpperCase()}
      </Avatar>
      <div className="single_widgets_description">
        <h2>{title}</h2>
        <p>
          {details}
        </p>
        <span onClick={() => navigate(`/viewapplicants/${id}`)}>
          <WidgetsButton Icon={AddIcon} title="View" RemoveImage={undefined} />
        </span>
      </div>
    </div>
  );
  return (
    <div className="widgets">
      <div className="widgets_header">
        <h2>Open Tasks <span>{screening?.slice(0, 5)?.length} of {screening?.length}</span></h2>
        <InfoIcon />
      </div>
      {isLoading ? (

        <div id="">
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7 subheading"></span>
            <span className="placeholder col-7 subheading"></span>
            <span className="placeholder col-12"></span>
            <span className="placeholder col-12"></span>
            <span className="placeholder col-12"></span>
            <span className="placeholder col-12"></span>
            <span className="placeholder col-12"></span>
            <span className="placeholder col-12"></span>
            <span className="placeholder col-12"></span>
          </p>
        </div>

      ) : screening?.length === 0 || screening?.length === undefined ? (
        <div>
          <div className="table-msg">
            <FaTicketAlt size={75} />
            <p>No Applicant found!</p>
          </div>
        </div>
      ) : (
        screening?.slice(0, 5)?.map((item: any, i: any) => (
          <div key={i}>
            <div className="widgets_body">
              {singleWidgets(item?.firstName + " " + item?.LastName, item?.applicationStatus, item?.id)}
            </div>

          </div>
        ))
      )}
      <div className="widgets_footer">
        <button onClick={() => navigate('/applicants')}>
          View all
          <ArrowForwardIcon />
        </button>
      </div>
    </div>
  );
}

export default Widget;
